import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8.26 9.376h1.603V7.818c0-.686.018-1.746.516-2.401.525-.695 1.247-1.167 2.488-1.167 2.021 0 2.873.287 2.873.287l-.401 2.375s-.668-.192-1.291-.192-1.181.222-1.181.845v1.811h2.556l-.178 2.319h-2.377v8.056H9.864v-8.056H8.261V9.376z"
}), 'Facebook');